import styled from '@emotion/styled'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import MakeItAContinuousConversationImage from './MakeItAContinuousConversationImage'

const copy = {
  heading: `Make it a continuous conversation`,
  description: `Build personalized customer journeys across tools and platforms based on rich, real-time data collection.`,
}

const MakeItAContinuousConversation = () => (
  <SectionBase variant="2Col" reverse={true}>
    <SectionCopy>
      <CopyTextBase>
        <CopyText.Heading tag="h2">{copy.heading}</CopyText.Heading>
        <CopyText.Description tag="p">{copy.description}</CopyText.Description>
      </CopyTextBase>
    </SectionCopy>
    <Section.Contents>
      <MakeItAContinuousConversationImage />
    </Section.Contents>
  </SectionBase>
)

const SectionCopy = styled(Section.Copy)`
  ${({ theme }) => theme.breakpoints.up(`lg`)} {
    max-width: 440px;
    justify-self: end;
    align-self: center;
  }
`

export default MakeItAContinuousConversation
